export type BusinessSize = '1-50' | '51-200' | '201-1000' | '1000+';
export type Urgency = 'low' | 'medium' | 'high';
export type Budget = 'low' | 'medium' | 'high';

export interface LeadScoreResult {
  score: number;
  category: 'hot' | 'warm' | 'cold';
}

export function calculateLeadScore(
  size: BusinessSize,
  urgency: Urgency,
  budget: Budget
): LeadScoreResult {
  let score = 0;

  // Company Size Scoring
  switch (size) {
    case '1-50': score += 10; break;
    case '51-200': score += 20; break;
    case '201-1000': score += 40; break;
    case '1000+': score += 60; break;
  }

  // Urgency Scoring
  switch (urgency) {
    case 'low': score += 10; break;
    case 'medium': score += 30; break;
    case 'high': score += 60; break;
  }

  // Budget Scoring
  switch (budget) {
    case 'low': score += 10; break;
    case 'medium': score += 30; break;
    case 'high': score += 60; break;
  }

  let category: 'hot' | 'warm' | 'cold' = 'cold';
  if (score >= 120) category = 'hot';
  else if (score >= 60) category = 'warm';

  return { score, category };
}
